import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import AuthGuard from 'utils/route-guard/AuthGuard';

const ExternalDashboard = Loadable(lazy(() => import('views/externalClient/MainExternalDashboard')));
const ExternalHostelFeeCollection = Loadable(lazy(() => import('views/externalClient/ExternalFeeCollectionEntry')));
const TransportPrevMonthCollection = Loadable(lazy(() => import('views/externalClient/TransportPrevMonthCollection')));
const TransportCurrentMonthCollection = Loadable(lazy(() => import('views/externalClient/TransportCurrentMonthCollection')));
const HostelDailyCollectionReport = Loadable(lazy(() => import('views/externalClient/HostelDailyCollection')));
const TransportDailyCollectionReport = Loadable(lazy(() => import('views/externalClient/TransportDailyCollection')));

const roles = ['ROLE_ADMIN', 'ROLE_COLLEGE_ADMIN', 'ROLE_SUPER_ADMIN', 'ROLE_COLLEGE_SUB_ADMIN'];

const ExternalRoutes = {
    path: '/',
    element: (
        <AuthGuard roles={roles}>
            <MainLayout />
        </AuthGuard>
    ),
    children: [
        {
            path: '/external/dashboard',
            element: <ExternalDashboard />
        },
        {
            path: '/offline/hostel/fee-collection',
            element: <ExternalHostelFeeCollection />
        },
        {
            path: '/transport/previous/month/collection',
            element: <TransportPrevMonthCollection />
        },
        {
            path: '/transport/current/month/collection',
            element: <TransportCurrentMonthCollection />
        },
        {
            path: '/daily/collection',
            element: <HostelDailyCollectionReport />
        },
        {
            path: '/daily/transport/collection',
            element: <TransportDailyCollectionReport />
        }
    ]
};
export default ExternalRoutes;
